/**
 * True when the current URL looks like the OAuth redirect back from Microsoft
 * (auth code, error, or dedicated callback path). Used so we never call
 * loginRedirect again on the same navigation after the auth code is already in the URL.
 */
export function isOAuthRedirectReturn() {
  try {
    const path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path.endsWith('/callback')) return true;
    const q = window.location.search || '';
    const h = window.location.hash || '';
    return (
      /[?&]code=/.test(q) ||
      /[?&]error=/.test(q) ||
      /(?:^|[&#])(code|error)=/.test(h)
    );
  } catch {
    return false;
  }
}
